import { Group } from "@mantine/core"
import { SuperAdminTenantTabs } from "src/components/superadmin/tenants/SuperAdminTenantTabs"
import { EditSuperAdminTenantAction } from "src/components/superadmin/tenants/SuperAdminTenantActions"
import { PageHeader } from "src/components/ui/PageHeader"
import { PageLayout } from "src/components/ui/PageLayout"
import { useAppState } from "src/state"
import { SuperAdminTenantView } from "src/components/superadmin/tenants/SuperAdminTenantView"

export function SuperAdminTenant() {

    const { currentItem } = useAppState(state=>state.tenants)

    return (
        <PageLayout
            header={
                <PageHeader
                    title={`${currentItem?.name}`}
                    renderAction={
                        <Group gap="sm">
                            <EditSuperAdminTenantAction />
                        </Group>
                    }
                />
            }
        >
            <SuperAdminTenantTabs/>
            <SuperAdminTenantView/>
        </PageLayout>
    )

}